import React from 'react';

interface IconProps {
    color?: string;  // Cor do ícone
    height?: string; // Altura do ícone
}

const HallIcon: React.FC<IconProps> = ({ color = "#000000", height = "24" }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15 15"
        height={height}
        width={height}
    >
        <path
            fill={color}
            d="M7.5 0L1 3.4453v.5547h13v-.5547zm-5.5 5v5l-1 1.5547v1.4453h13v-1.4453l-1-1.5547v-5zm2 1h1v5.5h-1zm3 0h1v5.5h-1zm3 0h1v5.5h-1z"
        />
    </svg>
);

export default HallIcon;
